/* eslint-disable react/prop-types */

/** @jsx jsx */
import { ChevronDown, ChevronUp } from 'gatsby-theme-docz/src/components/Icons';
import * as styles from 'gatsby-theme-docz/src/components/Props/styles';
import { useState } from 'react';
import { jsx } from 'theme-ui';
import { InlineCode } from '../../custom-components/InlineCode';
import { Container, defaultValue as propsDefaultValue, container as propsContainer, propName as propsPropName, propType as propsPropType, right as propsRight } from './custom-styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var getDefaultValue = function getDefaultValue(_ref) {
  var defaultValue = _ref.defaultValue,
      type = _ref.type,
      flowType = _ref.flowType;
  var propType = flowType ? flowType : type;
  if (!defaultValue || !defaultValue.value) return null;

  if (defaultValue.value === "''") {
    return '[Empty string]';
  }

  if (propType && propType.name === 'string') {
    return defaultValue.value.replace(/'/g, '"');
  }

  if (typeof defaultValue.value === 'object' && defaultValue.value.toString) {
    return defaultValue.value.toString();
  }

  return defaultValue.value;
};

if (typeof getDefaultValue !== 'undefined' && getDefaultValue && getDefaultValue === Object(getDefaultValue) && Object.isExtensible(getDefaultValue) && !Object.prototype.hasOwnProperty.call(getDefaultValue, '__filemeta')) {
  Object.defineProperty(getDefaultValue, '__filemeta', {
    configurable: true,
    value: {
      name: "getDefaultValue",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/index.js"
    }
  });
}

export var Prop = function Prop(_ref2) {
  var propName = _ref2.propName,
      prop = _ref2.prop,
      getPropType = _ref2.getPropType,
      isToggle = _ref2.isToggle;

  var _useState = useState(isToggle || false),
      showing = _useState[0],
      setShowing = _useState[1];

  if (!prop.type && !prop.flowType) return null;

  var toggle = function toggle() {
    return setShowing(function (s) {
      return !s;
    });
  };

  var defaultValue = getDefaultValue(prop);
  return jsx("div", {
    sx: styles.line,
    "data-testid": "prop"
  }, jsx("div", {
    sx: styles.content
  }, jsx("div", {
    sx: propsPropName,
    "data-testid": "prop-name"
  }, propName), jsx("div", {
    sx: propsPropType,
    "data-testid": "prop-type"
  }, getPropType(prop)), prop.defaultValue && jsx("div", {
    sx: propsDefaultValue,
    "data-testid": "prop-default-value",
    "data-hovertext": defaultValue.length > 150 ? defaultValue : undefined
  }, jsx("em", null, defaultValue)), jsx("div", {
    sx: propsRight
  }, prop.required && jsx("div", {
    sx: styles.propRequired,
    "data-testid": "prop-required"
  }, jsx("strong", null, "required")), prop.description && jsx("button", {
    sx: styles.openDescBtn,
    onClick: toggle,
    "data-testid": "prop-toggle-description"
  }, showing ? jsx(ChevronUp, {
    size: 20
  }) : jsx(ChevronDown, {
    size: 20
  })))), showing && prop.description && jsx("div", {
    sx: styles.description,
    "data-testid": "prop-description"
  }, prop.description));
};

if (typeof Prop !== 'undefined' && Prop && Prop === Object(Prop) && Object.isExtensible(Prop) && !Object.prototype.hasOwnProperty.call(Prop, '__filemeta')) {
  Object.defineProperty(Prop, '__filemeta', {
    configurable: true,
    value: {
      name: "Prop",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/index.js"
    }
  });
}

export var Props = function Props(_ref3) {
  var props = _ref3.props,
      table = _ref3.table,
      getPropType = _ref3.getPropType,
      isToggle = _ref3.isToggle;
  var entries = Object.entries(props);

  if (table) {
    return jsx(Container, null, jsx("table", null, jsx("thead", null, jsx("tr", null, jsx("th", {
      width: "17%"
    }, "Prop name"), jsx("th", {
      width: "25%"
    }, "Type"), jsx("th", {
      width: "9%"
    }, "Default"), jsx("th", {
      width: "9%"
    }, "Required"), jsx("th", {
      width: "40%"
    }, "Description"))), jsx("tbody", null, entries.map(function (_ref4) {
      var key = _ref4[0],
          prop = _ref4[1];
      return jsx("tr", {
        key: key
      }, jsx("td", null, key), jsx("td", null, jsx(InlineCode, null, getPropType(prop))), jsx("td", null, getDefaultValue(prop) || '—'), jsx("td", null, prop.required ? 'true' : 'false'), jsx("td", null, prop.description));
    }))));
  }

  return jsx("div", {
    sx: propsContainer,
    "data-testid": "props"
  }, entries.map(function (_ref5) {
    var key = _ref5[0],
        prop = _ref5[1];
    return jsx(Prop, {
      key: key,
      propName: key,
      prop: prop,
      getPropType: getPropType,
      isToggle: isToggle
    });
  }));
};

if (typeof Props !== 'undefined' && Props && Props === Object(Props) && Object.isExtensible(Props) && !Object.prototype.hasOwnProperty.call(Props, '__filemeta')) {
  Object.defineProperty(Props, '__filemeta', {
    configurable: true,
    value: {
      name: "Props",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/components/Props/index.js"
    }
  });
}